import type { MouseEvent } from 'react'
import { Link, type LinkProps } from 'react-router-dom'
import { america, findMission, missionPath } from '@/content/missions'
import { usePrefs } from '@/state/prefs'
import { useIsHome } from '@/state/useIsHome'
import { useReducedMotion } from '@/state/useReducedMotion'

/**
 * A link to the home page, at the chosen mission's own address. On the home
 * page itself it returns to the top instead and moves focus to the main
 * content, and clears any hash from the address, such as a shared design's.
 */
export default function HomeLink({ onClick, ...props }: Omit<LinkProps, 'to'>) {
  const { prefs } = usePrefs()
  const home = useIsHome()
  const reduced = useReducedMotion()
  const toTop = (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event)
    if (!home || event.defaultPrevented) return
    event.preventDefault()
    if (window.location.hash) window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search)
    window.scrollTo({ top: 0, behavior: reduced ? 'instant' : 'smooth' })
    document.getElementById('main')?.focus({ preventScroll: true })
  }
  return <Link to={missionPath(findMission(prefs.mission) ?? america)} onClick={toTop} {...props} />
}
